<template>
    <div class="container-card">
        <label class="label-titulo">{{ titulo }}</label>
        <hr class="linha" />
        <div class="div-valor">
            <label class="label-valor">{{ valor }}</label>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CardInfo',
    props: {
        titulo: {
            type: String,
            required: true
        },
        valor: {
            type: String,
            required: true
        }
    }
}
</script>

<style scoped>
.container-card {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    align-items: center;
    width: 100%;
    height: 110px;
    border-radius: 5px;
    background: var(--card-color);
    border: 1px solid #2983DD;
}

.label-titulo {
    font-weight: 400;
    font-size: 16px;
    text-align: center;
    padding-top: 10px;
}

.label-valor {
    font-weight: 600;
    font-size: 20px;
    line-height: 100%;
    text-align: center;
    vertical-align: middle;
}

.linha {
    width: 90%;
    top: 31px;
    left: 10px;
    border: 1px solid #414141;
}

.div-valor {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
}
</style>
